// extracted by mini-css-extract-plugin
export default {"sales-campaign-desc-wrapper":"sales-campaign-desc-wrapper_P1FgA","button-group":"button-group_uHVQe"};